import { LegalDocumentPage } from "./LegalDocumentPage";
import privacyPolicySource from "./privacy-policy.txt?raw";

export function PrivacyPolicyPage() {
  return <LegalDocumentPage source={privacyPolicySource} />;
}
